<template>
  <div>
    <div class="row text-muted g-0">
        <div class="col-3 text-center fs-13 ps-0" >
            <slot name="icon"></slot>
        </div>
        <div class="col-9">
            <slot name="detail"></slot>
        </div>  
    </div>    
  </div>
</template>

<script>

export default {
  data(){
    return{
      
    }
  },
  methods:{

  },
  computed:{

  },
  watch:{

  },
  components: {
   
  },
};


</script>

<style>

</style>